var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsedCoupon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/ticket-discount"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ticket-discount"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5 12.6802C19.5 11.3002 20.62 10.1802 22 10.1802V9.18018C22 5.18018 21 4.18018 17 4.18018H7C3 4.18018 2 5.18018 2 9.18018V9.68018C3.38 9.68018 4.5 10.8002 4.5 12.1802C4.5 13.5602 3.38 14.6802 2 14.6802V15.1802C2 19.1802 3 20.1802 7 20.1802H17C21 20.1802 22 19.1802 22 15.1802C20.62 15.1802 19.5 14.0602 19.5 12.6802Z",
    stroke: "#C4D26E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 14.9302L15 8.93018",
    stroke: "#C4D26E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.9945 14.9302H15.0035",
    stroke: "#C4D26E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.99451 9.43018H9.00349",
    stroke: "#C4D26E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsedCoupon);
export default __webpack_public_path__ + "static/media/usedCoupon.3cca58c03c566a55bce4bdb150ae7830.svg";
export { ForwardRef as ReactComponent };